import React from 'react';
import { FilterBar, FilterDefinition } from './common/FilterControls';

export interface EmailSendsFiltersState {
  search?: string;
  status?: string;
  list_id?: string;
}

interface EmailSendsFilterBarProps {
  filters: EmailSendsFiltersState;
  onFiltersChange: (filters: EmailSendsFiltersState) => void;
  onClearFilters: () => void;
  listOptions: { value: string; label: string }[];
}

const baseFilterDefs: FilterDefinition[] = [
  { type: 'text', field: 'search', label: 'Name', icon: 'bi-search', placeholder: 'Search by send name...' },
  {
    type: 'multiselect', field: 'status', label: 'Status', icon: 'bi-check-circle',
    options: [
      { value: 'sent', label: 'Sent' },
      { value: 'sending', label: 'Sending' },
      { value: 'scheduled', label: 'Scheduled' },
      { value: 'failed', label: 'Failed' },
    ],
  },
];

const EmailSendsFilterBar: React.FC<EmailSendsFilterBarProps> = ({ filters, onFiltersChange, onClearFilters, listOptions }) => {
  const filterDefs: FilterDefinition[] = [
    ...baseFilterDefs,
    {
      type: 'multiselect', field: 'list_id', label: 'List', icon: 'bi-list-ul',
      options: listOptions,
    },
  ];

  const handleFilterChange = (field: string, value: string | undefined) => {
    onFiltersChange({
      ...filters,
      [field]: value || undefined,
    });
  };

  return (
    <FilterBar
      filters={filters}
      filterDefs={filterDefs}
      onFilterChange={handleFilterChange}
      onClearFilters={onClearFilters}
    />
  );
};

export default EmailSendsFilterBar;
